import * as React from 'react';
import {Helmet} from 'react-helmet';

import Tabs from 'antd/lib/tabs';

import {useHistory} from 'react-router-dom';

import {Loading} from '@common/react/components/UI/Loading/Loading';
import {getBackgroundUrl} from '@common/typescript/Utils';

import {rest} from '@app/components/Api';
import MustheadNaked from '@app/components/UI/MustHead/MustheadNaked';
import AreaPreview from '@app/components/UI/Area-blocks/AreaPreview/AreaPreview';
import AreaAbout from '@app/components/UI/Area-blocks/AreaAbout/AreaAbout';
import AreaServices from '@app/components/UI/Area-blocks/AreaServices/AreaServices';
import AreaVets from '@app/components/UI/Area-blocks/AreaVets/AreaVets';
import AreaResources from '@app/components/UI/Area-blocks/AreaResources/AreaResources';
import { Area } from '@app/objects/Area';

import '@app/scss/components/area.scss';
import AreaRequestForm from '@app/components/UI/Area-blocks/AreaRequestForm/AreaRequestForm';
import AreaPageMobileNav from '@app/components/Pages/Area/AreaPageMobileNav';
import AreaMemorialKeepsakes from '@app/components/UI/Area-blocks/AreaMemorialKeepsakes/AreaMemorialKeepsakes';

export const AreaPageContext = React.createContext(null);

const AreaPage = (props) => {
	const currentAreaUrl = props.location.pathname.slice(0, -(props.match.params.tab.length) - 1);
	const history = useHistory();
	const urlArea = props.match.params.id;
	const { TabPane } = Tabs;
	const [area, setArea] = React.useState<Area>();
	const [scrollPosition, setScrollPosition] = React.useState<any>();

	React.useEffect(() => {
		scrollPosition ? localStorage.setItem('scroll', scrollPosition) : null;
	}, [scrollPosition]);

	React.useEffect(() => {
		rest.get<Area>(`v1/areas/url/${urlArea}`)
			.then((res) => {
				if (!res.id) {
					history.replace('/not-found');
				} else {
					setArea(res);
				}
			});
	}, [urlArea]);

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
	}, []);

	if (!area) {
		return <Loading />;
	}

	return  (
		<AreaPageContext.Provider value={currentAreaUrl} >
			{(area.title || area.name) && <Helmet>
				<title>{area.title || `${area.name} | Lap of Love`}</title>
				<meta name="description" property="og:description" content={area.description || undefined}/>
			</Helmet>}
			<AreaPageMobileNav
				currentAreaUrl={currentAreaUrl}
				activeTab={props.match.params.tab}
				additionalClass="area-page__mobile-nav"
			/>
			<div className="area-page">
				<MustheadNaked imageSrc={area.headerImage || require('@app/content/tampa-st-petersburg.jpg')}/>
				<div className="area-page__avatar area-page__avatar_mobile" style={{backgroundImage: getBackgroundUrl(area.avatar)}}/>
				<div className="area-page-body">
					<Tabs
						className="area-page-menu"
						activeKey={props.match.params.tab}
						tabPosition="left"
						tabBarExtraContent={<AreaPreview area={area} currentAreaUrl={currentAreaUrl}/>}
						onTabClick={(key, event) => {
							history.push(`${currentAreaUrl}/${key}`);
						}}
					>
							<>
								<TabPane tab="About"  key="about">
									<AreaAbout area={area}/>
								</TabPane>
								<TabPane tab="Pricing & Services" key="services">
									<AreaServices area={area}/>
								</TabPane>
								<TabPane tab="Veterinarians" key="veterinarians">
									<AreaVets area={area}/>
								</TabPane>
								<TabPane tab="Local Resources" key="resources">
									<AreaResources {...area}/>
								</TabPane>
								<TabPane tab="Pet Memorial Keepsakes" key="keepsakes">
									<AreaMemorialKeepsakes area={area}/>
								</TabPane>
								{
									props.match.params.tab === 'request-info' &&
									<AreaRequestForm area={area} />
								}

							</>
					</Tabs>
				</div>
			</div>
		</AreaPageContext.Provider>

	);
};

export default AreaPage;